class Pattern {
    constructor(name, steps, beats = 4) {
        this.id = Math.floor(Math.random() * 100000);
        this.name = name;
        this.beats = beats;
        this.steps = steps; //this._createSteps();  
    }
    get beatAmount() {
        const xValues = this.steps.map((step => step.endX));
        return Math.max(...xValues);
    }
    clone() {
        let steps = this.steps.map((step) => {
            let stepClone = step.clone();
            return stepClone;
        });
        let patternClone = new Pattern(this.name, steps, this.beats);
        patternClone.id = this.id;
        return patternClone;
    }
}
export default Pattern;
export { Pattern, };
